.logoutButton {
  border: none;
  background-color: var(--blue-01);
  color: var(--white);
  border-radius: 0 0 4px 4px;
  padding: 10px 15px;
  cursor: pointer;
  margin-top: -1px; // Move up to overlap the nav border
  outline: none;

  &:focus {
    box-shadow: 0 0 12px var(--highlight-blue);
  }
}
